import { Spinner } from "@heroui/react";
import { Navigate } from "react-router";
import { useAuth } from "@/src/auth/hooks/use-auth";
import { POST_ROUTES } from "@/src/post/constants/post-routes.constants";

export function HomeRedirect() {
	const { isAuthenticated, isInitialized } = useAuth();

	if (!isInitialized) {
		return (
			<div className="flex min-h-[50vh] items-center justify-center">
				<Spinner />
			</div>
		);
	}

	return <Navigate to={isAuthenticated ? POST_ROUTES.appFeed : POST_ROUTES.feed} replace />;
}
